import { render, staticRenderFns } from "./hospitalAdd.vue?vue&type=template&id=5dcefa8a&scoped=true"
import script from "./hospitalAdd.vue?vue&type=script&lang=js"
export * from "./hospitalAdd.vue?vue&type=script&lang=js"
import style0 from "./hospitalAdd.vue?vue&type=style&index=0&id=5dcefa8a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcefa8a",
  null
  
)

export default component.exports